import _ from 'lodash';
import { toolkitMixin } from '../item';
import { dollar } from '@/app/filters/filters';

export const pensionInstructionMixin = {
  mixins: [toolkitMixin],
  computed: {
    fund() {
      return this.$store.getters['fund/getFund'];
    },
    fundName() {
      return this.fund.details.name;
    },
    trusteeType() {
      return this.fund.trustee.type;
    },
    trustees() {
      return this.fund.trustee.trustees;
    },
    finYear() {
      return this.getItem.finYear;
    },
    members() {
      const { members } = this.getItem;
      return _.values(members);
    },
    numMembers() {
      return this.members.length;
    },
    ratify() {
      return this.getItem.ratify.value;
    },
    showAccounts() {
      return (rule) => {
        if (typeof rule === 'string') return false;

        const { accounts, extra } = rule;
        const { accounts: ruleAccounts, type } = accounts;

        if (type !== 'pension') return false;

        switch (ruleAccounts) {
          case 'all':
            if (extra.input) return true;
            return false;
          case 'multiple':
            return true;
          case 'single':
          default:
            return false;
        }
      };
    },
    processedPDF() {
      return (instruction) => {
        let output = instruction.PDF;
        const { ruleAccounts } = instruction.accounts;
        if (output.search('<%member%>') > 0) {
          ruleAccounts.forEach((account) => {
            if (this.numMembers > 1) {
              output = output.replace('<%member%>', account.member.name);
            } else {
              output = output.replace(' held by <%member%>', '');
              // Rule 6 has a different mark up to other single rules
              output = output.replace('<%member%>:', '');
            }
          });
        }
        if (output.search('<%identifier%>') > 0) {
          ruleAccounts.forEach((account) => {
            output = output.replace('<%identifier%>', account.identifier);
          });
        }

        if (output.search('<%percent%>') > 0) {
          ruleAccounts.forEach((account) => {
            output = output.replace('<%percent%>', account.value);
          });
        }

        if (output.search('<%amount%>') > 0) {
          output = output.replace('<%amount%>', dollar(instruction.until.inputValue));
        }

        return output;
      };
    },
  },
};

export default pensionInstructionMixin;
